import React, { useEffect } from 'react';

import { t } from 'i18next';

import ChallengeDescriptionForm from './sections/DescriptionForm/ChallengeDescriptionForm';
import ChallengeDescriptionPreview from './sections/DescriptionPreview/ChallengeDescriptionPreview';
import { IChallengeDescription } from '../../../../../shared/interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../../../../../shared/translations/challenges';
import { daysUntil } from '../../../../../shared/utils/datetime/datetime';
import './ChallengeDescription.scss';

const ChallengeDescription = ({
  updateChallenge,
  challenge,
  circleIndicatorIconUrl,
  setStepReady
}: IChallengeDescription) => {
  const [formValues, setFormValues] = React.useState({
    title: challenge?.name || '',
    description: challenge?.description || ''
  });

  useEffect(() => {
    if (formValues.title && formValues.title != '' && formValues.description && formValues.description != '') {
      updateChallenge({ name: formValues.title, description: formValues.description });
      setStepReady(true);
    } else setStepReady(false);
  }, [formValues]);

  const handleChange = (title?: string, description?: string) => {
    setFormValues((prevValues) => ({
      title: title ?? prevValues.title,
      description: description ?? prevValues.description
    }));
  };

  const titleToDisplay = formValues.title || t(TRANSLATION_CHALLENGES.description.global_title);
  const descriptionToDisplay = formValues.description || t(TRANSLATION_CHALLENGES.description.create_challenge);

  return (
    <div className="describe-challenge-section">
      <ChallengeDescriptionForm
        title={formValues.title}
        description={formValues.description}
        onChangeTitle={(v) => handleChange(v)}
        onChangeDescription={(v) => handleChange(undefined, v)}
      />
      <ChallengeDescriptionPreview
        title={titleToDisplay}
        description={descriptionToDisplay}
        daysLeft={challenge ? daysUntil(challenge.endAt) : 999}
        rewardsPoints={100}
        circleIndicatorIconUrl={circleIndicatorIconUrl}
      />
    </div>
  );
};

export default ChallengeDescription;
